export type ApplicationHost = 'proposal' | 'staff';

export const selectApplicationHost = (hostname: string): ApplicationHost =>
  hostname.toLowerCase() === 'proposals.zube.ai' ? 'proposal' : 'staff';

export interface BootstrapApplicationOptions {
  readonly hostname: string;
  readonly loadProposal: () => Promise<void>;
  readonly loadStaff: () => Promise<void>;
}

export const bootstrapApplication = async ({
  hostname,
  loadProposal,
  loadStaff
}: BootstrapApplicationOptions): Promise<void> => {
  if (selectApplicationHost(hostname) === 'proposal') {
    await loadProposal();
    return;
  }

  await loadStaff();
};
